import { CareComponentConfiguration, GetFlowsheetTemplateResponse } from "../Api/Contracts/GetFlowsheetTemplate";
import { FlowsheetConstants } from "../FlowsheetConstants";
import { CareComponentConfig } from "../Models/CareElements/CareComponentConfig";
import { FlowsheetConfig } from "../Models/CareElements/FlowsheetConfig";
import { VitalSignsCareElementConfig } from "../Models/CareElements/VitalSignsCareElementConfig";
import { FlowsheetTemplate, FlowsheetTemplateScope } from "../Models/FlowsheetTemplate";
/**
 * Maps a GetFlowsheetTemplateResponse object to a FlowsheetTemplate object.
 *
 * @param response - The response object containing flowsheet template data.
 * @returns A new FlowsheetTemplate object with the mapped data.
 */
function getFlowsheetTemplateResponseToFlowsheetTemplate(response: GetFlowsheetTemplateResponse): FlowsheetTemplate {
    return new FlowsheetTemplate({
        Id: response.Id,
        Name: response.Name,
        Configuration: new FlowsheetConfig(
            {
                CareComponents: processCareComponents(response.Configuration)
            }
        ),
        TemplateScope: response.TemplateScope,
        IsDefaultTemplate: response.TemplateScope === FlowsheetTemplateScope.Default
    });
}

function processCareComponents(careComponents: CareComponentConfiguration[]): CareComponentConfig[] {
    return careComponents.map(careComponent => {
        if (careComponent.Name === FlowsheetConstants.VitalSigns.CareComponentName) {
            const vitalSignCareElements = careComponent.CareElements as VitalSignsCareElementConfig[];
            const systolicIndex = vitalSignCareElements.findIndex(e => e.Name === FlowsheetConstants.VitalSigns.BloodPressureSystolicCareElementName);
            const diastolicIndex = vitalSignCareElements.findIndex(e => e.Name === FlowsheetConstants.VitalSigns.BloodPressureDiastolicCareElementName);

            if (systolicIndex !== -1 && diastolicIndex !== -1) {
                const systolic = vitalSignCareElements[systolicIndex];
                const diastolic = vitalSignCareElements[diastolicIndex];
                const mergedBloodPressure = createMergedBloodPressure(systolic, diastolic);

                careComponent.CareElements = [
                    ...vitalSignCareElements.slice(0, systolicIndex),
                    mergedBloodPressure,
                    ...vitalSignCareElements.slice(systolicIndex + 1).filter(e => e.Name !== FlowsheetConstants.VitalSigns.BloodPressureDiastolicCareElementName)
                ];
            }
        }

        return {
            Name: careComponent.Name,
            CareElementsConfig: careComponent.CareElements,
            Expanded: careComponent.IsExpanded
        };
    });
}

function createMergedBloodPressure(
    systolic: VitalSignsCareElementConfig,
    diastolic: VitalSignsCareElementConfig
): VitalSignsCareElementConfig {
    return new VitalSignsCareElementConfig({
        Name: FlowsheetConstants.VitalSigns.BloodPressureCareElementName,
        Frequency: systolic.Frequency ?? diastolic.Frequency,
        TargetRange: { LowerBound: systolic.TargetRange?.LowerBound, UpperBound: diastolic.TargetRange?.LowerBound },
        Operator: systolic.Operator ?? diastolic.Operator,
        Unit: systolic.Unit ?? diastolic.Unit
    });
}

export default getFlowsheetTemplateResponseToFlowsheetTemplate;
